import { Box, ClickAwayListener, IconButton, Popper } from "@mui/material";
import { memo, useState,useCallback } from "react";

const CustomClickAwayPopup = ({icon, placement="bottom", children}) => {
    const [popupFlag, setFilterPopupFlag] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null);

    const showPopper = useCallback((event) => {
        setFilterPopupFlag(true)
        setAnchorEl(event.currentTarget)
    })

    const handleClose = useCallback(() => {
        setFilterPopupFlag(false)
        setAnchorEl(null)
    })

    return <ClickAwayListener onClickAway={handleClose}>
        <Box sx={{ position: 'relative', justifyContent: 'flex-end', textAlign: 'right' }}>
            <IconButton disabled={false} className="form-icon-btn" size="small" onClick={showPopper}> {icon} </IconButton>
            <Popper
                open={popupFlag}
                anchorEl={anchorEl}
                id="long-menu"
                onClose={e => handleClose(false)}
                placement={placement}
                popperOptions={{ positionFixed: true }}
                sx={{
                    minWidth: 100, maxHeight: '400px', overflow: 'visible', zIndex: 9
                }}
            >
                <Box className={'re-theme2'} sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', borderRadius: '8px', marginTop: '16px', boxShadow: '0 0 4px #00000029' }} >
                    {children}
                </Box>
            </Popper>
        </Box>
    </ClickAwayListener>
}

export default memo(CustomClickAwayPopup)